import KondoHeader from '../Header';
import KondoFooter from '../Footer';
import ContactForm from '../ContactForm';
import ContactButton from '../ContactButton'
import Pankuzu from '../pankuzu';
import PrivacyTop from "../../images/ContactTop.png";
import tel_icon from "../../images/tel_icon.png"
import fax_icon from "../../images/fax_icon.png"
import mail_icon from "../../images/mail_icon.png"

// animation
import {motion} from "framer-motion"

const PageContact = () => {
    return(
        <div id="PageKondou">  
            <div id="PageContact">
                <KondoHeader />
                <motion.div
                    animate={{
                        y: 0,
                        opacity: 1
                    }}
                    initial={{
                        y: 0,
                        opacity: 1
                    }}
                    exit={{
                        y: 100,
                        opacity: 0
                    }}
                    transition={{
                        duration: 0.4,
                        ease: "easeOut",
                    }}
                >
                    <main>
                        <section className='contact-top'>
                            <img src={PrivacyTop} alt='お問い合わせのトップ画像' />
                            <Pankuzu pagename="お問い合わせ" />
                            <article>
                                <h1>CONTACT</h1>
                                <h2>お問い合わせ</h2>
                            </article>
                            <section className='contact-contents'>
                                <h3>
                                    当館へのご質問・お問い合わせは以下のメールフォーム、お電話にてお気軽にお問い合わせくださいませ。<br/>
                                    後日メール又はお電話にて回答させていただきます。<br/>
                                    24時間経っても返信がない場合、お手数ですが下記の電話番号までお問い合わせください。
                                </h3>
                                <div className='contact-details'>
                                    <div>
                                        <img src={tel_icon} alt="電話アイコン" />
                                        <h2>お電話でのお問い合わせ</h2>
                                        <h3>0166-22-2255</h3>
                                        <h4>8:30～17:00受付</h4>
                                    </div>
                                    <div>
                                        <img src={fax_icon} alt="FAXアイコン" />
                                        <h2>FAXでのお問い合せ</h2>
                                        <h3>0166-24-5406</h3>
                                        <h4>24時間受付</h4>
                                    </div>
                                    <ContactForm />
                                </div>
                            </section>
                        </section>
                    </main>
                    <KondoFooter />
                </motion.div>
            </div>
        </div>
    )
}
export default PageContact;